export default class SessionIdHelper {
    static checkSessionId(sessionId) {
        return (/([a-z0-9-]{10,32})\w+/g.test(sessionId));
    }
}